import _toConsumableArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
var __jsx = React.createElement;
import React, { useState } from 'react';
import { useLang } from '@/common/Contexts/LanguageContext';
import { Icon } from '@syarahtech/ui';
import { useTranslation } from '@i18n';
/**
 * Derives overall min / max / avg price from already-resolved rows.
 * carPricesDataStructure is pre-filtered to the current language by the server.
 */
function deriveAggregatePrice(rows) {
  if (!(rows !== null && rows !== void 0 && rows.length)) return null;
  var mins = rows.map(function (r) {
    return Number(r.min_price);
  }).filter(Boolean);
  var maxs = rows.map(function (r) {
    return Number(r.max_price);
  }).filter(Boolean);
  var avgs = rows.map(function (r) {
    return Number(r.avg_price);
  }).filter(Boolean);
  if (!mins.length) return null;
  var min = Math.min.apply(Math, _toConsumableArray(mins));
  var max = Math.max.apply(Math, _toConsumableArray(maxs));
  var avg = Math.round(avgs.reduce(function (a, b) {
    return a + b;
  }, 0) / avgs.length);
  return {
    min: min,
    max: max,
    avg: avg
  };
}
var PricesFAQSection = function PricesFAQSection(_ref) {
  var slug = _ref.slug,
    selectedMake = _ref.selectedMake,
    selectedModel = _ref.selectedModel,
    year = _ref.year,
    carPricesDataStructure = _ref.carPricesDataStructure;
  var lang = useLang();
  var _useTranslation = useTranslation(['car_prices']),
    tShort = _useTranslation.tShort;
  var _useState = useState(0),
    activeFaqIndex = _useState[0],
    setActiveFaqIndex = _useState[1];

  // Only show on make / model / year pages
  var isApplicable = slug === 'cars-prices-make' || slug === 'cars-prices-make-model' || slug === 'cars-prices-make-model-year';
  if (!isApplicable || !selectedMake) return null;
  var prices = deriveAggregatePrice(carPricesDataStructure);
  if (!prices) return null;
  var makeName = (selectedMake === null || selectedMake === void 0 ? void 0 : selectedMake.name) || '';
  var modelName = (selectedModel === null || selectedModel === void 0 ? void 0 : selectedModel.name) || '';

  // Build the display label: "[Make]", "[Make Model]" or "[Make Model Year]"
  var carLabel = [makeName, modelName, year || ''].filter(Boolean).join(' ');
  var formatPrice = function formatPrice(p) {
    return p.toLocaleString();
  };
  var faqs = [{
    question: tShort('prices_faq/cheapest_question', {
      ns: 'car_prices',
      car: carLabel
    }),
    answer: tShort('prices_faq/cheapest_answer', {
      ns: 'car_prices',
      car: carLabel,
      price: formatPrice(prices.min)
    })
  }, {
    question: tShort('prices_faq/highest_question', {
      ns: 'car_prices',
      car: carLabel
    }),
    answer: tShort('prices_faq/highest_answer', {
      ns: 'car_prices',
      car: carLabel,
      price: formatPrice(prices.max)
    })
  }, {
    question: tShort('prices_faq/average_question', {
      ns: 'car_prices',
      car: carLabel
    }),
    answer: tShort('prices_faq/average_answer', {
      ns: 'car_prices',
      car: carLabel,
      price: formatPrice(prices.avg)
    })
  }, {
    question: tShort('prices_faq/source_question', {
      ns: 'car_prices'
    }),
    answer: tShort('prices_faq/source_answer', {
      ns: 'car_prices'
    })
  }];
  var toggleFaq = function toggleFaq(index) {
    setActiveFaqIndex(activeFaqIndex === index ? -1 : index);
  };
  return /*#__PURE__*/React.createElement("section", {
    id: "prices-faq-section",
    className: "my-4 md:my-20 px-5 md:px-4"
  }, /*#__PURE__*/React.createElement("div", {
    id: "prices-faq-container",
    className: "mx-auto md:max-w-[1200px]"
  }, /*#__PURE__*/React.createElement("h2", {
    id: "prices-faq-title",
    className: "text-center text-primary-old font-bold md:text-[32px] text-2xl mt-10 mb-6 md:mb-10"
  }, tShort('prices_faq/title', {
    ns: 'car_prices'
  })), /*#__PURE__*/React.createElement("div", {
    id: "prices-faq-items-container",
    className: "space-y-4"
  }, faqs.map(function (faq, index) {
    return /*#__PURE__*/React.createElement("div", {
      id: "prices-faq-item-".concat(index),
      className: "border-[1px] border-solid border-[#D6DFE9] rounded-lg overflow-hidden",
      key: index,
      onClick: function onClick() {
        return toggleFaq(index);
      }
    }, /*#__PURE__*/React.createElement("div", {
      id: "prices-faq-item-header-".concat(index),
      className: "flex justify-between ".concat(activeFaqIndex === index ? 'items-start' : 'items-center', " gap-2 p-5 sm:p-4 cursor-pointer transition-all duration-300 ease-in-out")
    }, /*#__PURE__*/React.createElement("span", {
      id: "prices-faq-item-question-".concat(index),
      className: "text-4 sm:text-3 sm:line-height-6 font-bold text-primary-old text-right rtl:text-right ltr:text-left leading-7"
    }, faq.question), /*#__PURE__*/React.createElement("span", {
      id: "prices-faq-item-toggle-icon-".concat(index),
      className: "flex items-center justify-center text-primary-old shrink-0 w-6 h-6"
    }, activeFaqIndex === index ? /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-up-rounded"
    }) : /*#__PURE__*/React.createElement(Icon, {
      width: 6,
      height: 6,
      icon: "material-symbols--keyboard-arrow-down-rounded"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "prices-faq-item-answer-".concat(index),
      className: "p-[0_20px_20px] text-4 sm:text-3 sm:line-height-4 leading-[1.6] text-[#6B7EA5] text-right rtl:text-right ltr:text-left ".concat(activeFaqIndex !== index ? 'hidden' : '')
    }, faq.answer));
  }))));
};
export default PricesFAQSection;